<template>
  <header>
    <transition name="book-flip" mode="out-in">
      <span class="logo create-room" v-if="path === '/topic-rooms'"
        >Create a room</span
      >
      <div v-else-if="path === '/chat'">
        <div class="title">
          <router-link to="/">
            <button>
              <div>
                <i class="fas fa-angle-left fa-2x"></i>
              </div>
            </button>
          </router-link>
          <h3 v-if="room_name === ''">
            <i class="admin-badge" v-if="thePartner.isAdmin"></i>
            {{ thePartner.name }}
          </h3>
          <span v-if="room_name === ''"
            >({{ thePartner.details.gender }}, {{ thePartner.age }},
            {{ thePartner.details.country }})</span
          >
          <h3 v-if="room_name !== ''">{{ room_name }}</h3>
        </div>
      </div>
      <span class="logo" v-else>Neptone</span>
    </transition>
    <button @click="showNav"><i class="fas fa-bars fa-2x"></i></button>
  </header>
</template>

<script>
export default {
  name: "WHeader",
  data() {
    return {
      path: "",
    };
  },
  methods: {
    showNav() {
      this.$store.commit("toggleNav", true);
    },
  },
  computed: {
    admins_list() {
      return this.$store.state.admins_list;
    },
    room_name() {
      return this.$store.state.user.room_name;
    },
    thePartner() {
      return this.$store.state.partner;
    },
  },
  watch: {
    $route(to) {
      this.path = to.path;
    },
  },
};
</script>

<style lang="scss">
header {
  direction: ltr;
  z-index: 2;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px;
  background-color: var(--bg2);
  box-shadow: 0 1px 8px -2px var(--shadow);
  background-color: var(--bg2);

  .title {
    display: flex;
    align-items: center;
    button {
      transform: translateY(1px);
    }
    h3 {
      font-size: 1.4em;
      margin: 0 10px;
    }
  }

  img {
    height: 120%;
  }

  button {
    height: 100%;
    color: var(--text);
  }

  span.logo {
    color: white;
    font-weight: bold;
    background-color: var(--accent);
    width: fit-content;
    padding: 10px 14px;
    border-radius: 10px;
    &.create-room {
      cursor: pointer;
    }
  }
}
</style>
